import * as React from 'react';
import PeriodsTable from './PeriodTable';

function PeriodDashboard() {
  return (
    <div>
      <PeriodsTable />
    </div>
  );
}

export default PeriodDashboard;
